import React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { NavLink, useNavigate } from 'react-router-dom';
import {Menu, Dropdown, Layout, Image} from 'antd';
import { isAdmin } from './RolesHelper';
import logo from "../../assets/btcLogo.png";

const { Header } = Layout;

const Navbar: React.FC = () => {
    const { keycloak } = useKeycloak();
    const navigate = useNavigate();

    const handleLogInOut = () => {
        if (keycloak.authenticated) {
            // Explizit zu /glow nach dem Logout umleiten
            keycloak.logout({
                redirectUri: window.location.origin + '/glow'
            });
        } else {
            keycloak.login();
        }
    };

    const getUsername = (): string | undefined => {
        return keycloak.authenticated ? keycloak.tokenParsed?.preferred_username : undefined;
    };

    const getLogInOutText = (): string => {
        return keycloak.authenticated ? 'Ausloggen' : 'Einloggen';
    };

    const getAdminMenuStyle = (): React.CSSProperties => {
        return keycloak.authenticated && isAdmin(keycloak) ? { display: 'block' } : { display: 'none' };
    };

    const userMenuItems = [
        {
            key: 'user',
            label: <NavLink to="/user1">Demnächst</NavLink>,
        },
    ];

    const dropdownMenu = {
        items: userMenuItems,
    };

    const getWelcomeMessage = () => {
        const username = getUsername();
        if(username){
            return "Hallo " + username;
        } else {
            return ""
        }
    }

    const menuItems = [
        {
            key: 'logo',
            label: <Image src={logo} preview={false} alt="Logo" />,
        },
        {
            key: 'right',
            label: keycloak.authenticated ? (
                <Dropdown menu={dropdownMenu}>
                    <span>{getWelcomeMessage()}</span>
                </Dropdown>
            ) : null,
            style: { marginLeft: 'auto' },
        },
        {
            key: 'login',
            label: getLogInOutText(),
            onClick: handleLogInOut,
        },
    ];

    return (
        <Header>
            <Menu
                theme="dark"
                mode="horizontal"
                selectable={false}
                items={menuItems}
            />
        </Header>
    );
};

export default Navbar;
